import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import axios from 'axios';

const UserSignupChart = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSignupStats = async () => {
      try {
        const res = await axios.get('https://reviewhub-lc.onrender.com/api/auth/signup-stats'); // Adjust path as needed
        setData(res.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching signup stats:', err);
        setLoading(false);
      }
    };

    fetchSignupStats();
  }, []);

  return (
    <Paper elevation={3} sx={{ padding: 3, mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        Monthly User Signups
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="count" fill="#3f51b5" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default UserSignupChart;
